import { render, staticRenderFns } from "./BirReportV2.vue?vue&type=template&id=055e2c2e&"
import script from "./BirReportV2.vue?vue&type=script&lang=js&"
export * from "./BirReportV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports